var _defs, _path, _path2, _g, _g2, _g3, _g4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreeceLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M55.96 35.83c-2.9 0-5.26-2.37-5.26-5.28v-11.2h-.27c-2.95 0-5.34-2.4-5.34-5.36s2.4-5.37 5.34-5.37h11.25c2.95 0 5.34 2.41 5.34 5.37s-2.4 5.36-5.34 5.36h-.27v11.2c0 2.91-2.36 5.28-5.26 5.28h-.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M81.42 40.55c-7.57 0-13.73-6.29-13.73-14.02s6.16-14.02 13.73-14.02 13.73 6.29 13.73 14.02-6.16 14.02-13.73 14.02zm0-17.45c-1.81 0-3.28 1.54-3.28 3.43s1.47 3.43 3.28 3.43 3.28-1.54 3.28-3.43-1.47-3.43-3.28-3.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M81.42 15.14c-6.13 0-11.1 5.1-11.1 11.39s4.97 11.39 11.1 11.39 11.1-5.1 11.1-11.39-4.97-11.39-11.1-11.39zm0 17.45c-3.26 0-5.91-2.72-5.91-6.06s2.65-6.06 5.91-6.06 5.91 2.72 5.91 6.06c0 3.35-2.65 6.06-5.91 6.06z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.895 31.686h86.211v36.628H6.895z",
    fill: "#fd0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07 50.228h81.869v1.131H9.07zm0 13.534h81.869v1.131H9.07zm0-2.71h81.869v1.131H9.07zm0-2.701h81.869v1.131H9.07zm0-2.71h81.869v1.131H9.07zm0-2.701h81.869v1.131H9.07zm0-5.412h81.869v1.131H9.07zm0-2.71h81.869v1.131H9.07zm0-2.701h81.869v1.131H9.07zm0-2.71h81.869v1.131H9.07zm0-2.701h81.869v1.131H9.07z",
    fill: "#fff34e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bc8405"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.486 60.753a4.63 4.63 0 0 1-4.614-4.631v-9.824h-.237a4.7 4.7 0 0 1-4.684-4.701c0-2.596 2.105-4.71 4.684-4.71h9.867c2.587 0 4.684 2.114 4.684 4.71 0 2.587-2.105 4.701-4.684 4.701h-.237v9.824a4.63 4.63 0 0 1-4.614 4.631h-.167zm22.331 4.14c-6.64 0-12.043-5.517-12.043-12.297s5.403-12.297 12.043-12.297S90.86 45.816 90.86 52.596c-.009 6.78-5.403 12.297-12.043 12.297zm0-15.314c-1.588 0-2.877 1.351-2.877 3.008s1.289 3.008 2.877 3.008 2.877-1.351 2.877-3.008-1.298-3.008-2.877-3.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.24 66.533a4.63 4.63 0 0 1-4.614-4.631v-9.824h-.237c-2.587 0-4.684-2.105-4.684-4.701s2.105-4.71 4.684-4.71h9.876c2.587 0 4.684 2.114 4.684 4.71a4.7 4.7 0 0 1-4.684 4.701h-.237v9.824a4.63 4.63 0 0 1-4.614 4.631h-.175zm-22.305-1.64c-6.64 0-12.043-5.517-12.043-12.297s5.403-12.297 12.043-12.297 12.043 5.517 12.043 12.297-5.403 12.297-12.043 12.297zm0-15.314c-1.588 0-2.877 1.351-2.877 3.008s1.289 3.008 2.877 3.008 2.877-1.351 2.877-3.008-1.289-3.008-2.877-3.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.989 65.376a4.637 4.637 0 0 1-4.193-2.675l-2.614-5.613-2.614 5.622a4.605 4.605 0 0 1-4.184 2.666 4.666 4.666 0 0 1-1.947-.43l-.149-.07a4.67 4.67 0 0 1-2.245-6.157l6.684-14.349c.491-1.053 1.5-3.237 4.447-3.237 2.965.026 3.973 2.193 4.456 3.237l6.684 14.341a4.657 4.657 0 0 1-2.219 6.149l-.175.079a4.438 4.438 0 0 1-1.93.439z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc300"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.269 3.648) scale(.8771)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 27.846,
    x: 6.704
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 27.846,
    x: 6.704
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 16.694,
    y: 34.446
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: -34.206,
    y: 27.846
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.734 64.121a4.63 4.63 0 0 1-4.193-2.684l-2.614-5.605-2.614 5.613a4.614 4.614 0 0 1-4.184 2.675 4.666 4.666 0 0 1-1.947-.43l-.149-.07c-2.307-1.088-3.307-3.85-2.237-6.149l6.684-14.349c.491-1.053 1.509-3.237 4.447-3.237 2.965.026 3.973 2.193 4.456 3.237l6.684 14.341a4.657 4.657 0 0 1-2.219 6.149l-.175.079a4.47 4.47 0 0 1-1.938.43z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.232 58.438a3.563 3.563 0 0 1-3.552-3.57V43.983h-1.298c-2 0-3.622-1.631-3.622-3.64s1.623-3.64 3.622-3.64h9.867c2 0 3.622 1.631 3.622 3.64s-1.623 3.64-3.622 3.64h-1.298v10.885a3.57 3.57 0 0 1-3.552 3.57h-.167zm22.331 4.14c-6.052 0-10.973-5.043-10.973-11.236s4.921-11.236 10.973-11.236 10.973 5.043 10.973 11.236-4.921 11.236-10.973 11.236zm0-15.314c-2.175 0-3.938 1.824-3.938 4.079 0 2.245 1.763 4.079 3.938 4.079s3.938-1.824 3.938-4.079c0-2.245-1.763-4.079-3.938-4.079z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.994 64.218a3.561 3.561 0 0 1-3.552-3.561V49.763h-1.298c-2 0-3.622-1.631-3.622-3.64s1.623-3.64 3.622-3.64h9.867c2 0 3.622 1.631 3.622 3.64s-1.623 3.64-3.622 3.64h-1.298v10.894a3.561 3.561 0 0 1-3.552 3.561h-.167zm-22.314-1.64c-6.052 0-10.973-5.043-10.973-11.236s4.921-11.236 10.973-11.236 10.973 5.043 10.973 11.236c.009 6.192-4.921 11.236-10.973 11.236zm0-15.314c-2.175 0-3.938 1.824-3.938 4.079 0 2.245 1.763 4.079 3.938 4.079s3.938-1.824 3.938-4.079c.009-2.245-1.763-4.079-3.938-4.079z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.734 63.06a3.536 3.536 0 0 1-3.219-2.061l-3.579-7.683-3.579 7.683a3.561 3.561 0 0 1-4.719 1.719l-.149-.07a3.587 3.587 0 0 1-1.719-4.736l6.684-14.349c.456-.982 1.219-2.623 3.482-2.623 2.289.018 3.017 1.588 3.491 2.623l6.684 14.341a3.587 3.587 0 0 1-1.71 4.736l-.167.079a3.44 3.44 0 0 1-1.5.342z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#034ea1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.714 42.738v12.13a2.32 2.32 0 0 1-2.307 2.324h-.167a2.32 2.32 0 0 1-2.307-2.324v-12.13h-2.535a2.403 2.403 0 0 1-2.386-2.395c0-1.316 1.07-2.403 2.386-2.403h9.867c1.307 0 2.377 1.088 2.377 2.403a2.395 2.395 0 0 1-2.377 2.395h-2.552z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    y: 27.846,
    x: 6.704,
    transform: "translate(.269 3.648) scale(.8771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.468 48.526v12.13a2.32 2.32 0 0 1-2.307 2.324h-.167a2.32 2.32 0 0 1-2.307-2.324v-12.13h-2.535a2.396 2.396 0 0 1-2.386-2.395c0-1.316 1.07-2.403 2.386-2.403h9.867c1.316 0 2.377 1.079 2.377 2.403a2.395 2.395 0 0 1-2.377 2.395h-2.552z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: -34.206,
    y: 27.846,
    transform: "translate(.269 3.648) scale(.8771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.963 42.194c1.403.009 1.824.807 2.333 1.903l6.684 14.341a2.342 2.342 0 0 1-1.114 3.087l-.158.07a2.31 2.31 0 0 1-3.07-1.123l-4.71-10.104-4.701 10.104a2.31 2.31 0 0 1-3.07 1.123l-.158-.07a2.334 2.334 0 0 1-1.114-3.087l6.684-14.341c.509-1.114.982-1.921 2.395-1.903z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-17 50h1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeceLotto);
export default __webpack_public_path__ + "static/media/greece_lotto.62569e09453cc89026019c03ae711f42.svg";
export { ForwardRef as ReactComponent };